import styled, { css } from 'styled-components';
import { TourDialogBox } from './MapTourDialogBox.styled';
import { DialogBoxContent, GuidedTourButton } from 'components/common/GuidedTour/GuidedTour.styled';

export const MapTourWrapper = styled.div`
    ${TourDialogBox} {
        position: fixed;
        right: 4rem;
        bottom: 11.2rem;

        @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
            right: 2.4rem;
            max-width: calc(100% - 10.2rem);
        }
    }

    ${GuidedTourButton} {
        @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
            right: 2.4rem;
        }
    }

    ${DialogBoxContent} {
        .path-icon {
            width: 2rem;
            height: 2rem;
            margin-bottom: -0.5rem;
        }
    }
`;

export const mapTourActiveElementAnimationStyles = css`
    @keyframes animate {
        0% {
            box-shadow: 0 0 0 ${({ theme }) => theme.colors.coral[500]};
        }

        50% {
            box-shadow: 0 0 1.5rem ${({ theme }) => theme.colors.coral[500]};
        }

        100% {
            box-shadow: 0 0 0 ${({ theme }) => theme.colors.coral[500]};
        }
    }

    &::before {
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        position: absolute;
        animation: animate 2s linear infinite;
        border-radius: 0.8rem;
    }
`;

export const mapTourActiveElementStyles = css`
    border: 0.1rem solid ${({ theme }) => theme.colors.coral[500]};
    background: ${({ theme }) => theme.colors.coral[50]};
    border-radius: 0.8rem;
    box-sizing: border-box;
    ${mapTourActiveElementAnimationStyles}
`;

export const StationIconsWrapper = styled.div`
    display: flex;
    gap: 0.8rem;
    margin-top: 1rem;
`;
